﻿import { LutData } from '../../Utilities/LutApi';

export const SET_LUTDATA = 'SET_LUTDATA';

export interface SetLutDataAction {
    type: typeof SET_LUTDATA;
    payload: LutData;
}

export type LutDataActionTypes = SetLutDataAction;
